import { RouteConfig } from 'vue-router';
const PAGE_TITLE = '圆梦高考 心想事橙';
const baseUrl = 'YDJM0515';
const route: RouteConfig = {
  path: `/${baseUrl}`,
  name: baseUrl,
  component: () => import('./ViewHolder.vue'),
  redirect: `/${baseUrl}/home`,
  meta: {
    title: PAGE_TITLE,
    showfooter: true,
  },
  children: [
    {
      path: 'home',
      name: `${baseUrl}-home`,
      component: () => import('./pages/Home.vue'),
      meta: {
        title: PAGE_TITLE,
        showfooter: false,
      },
    },
    {
      path: 'active',
      name: `${baseUrl}-active`,
      component: () => import('./pages/Active.vue'),
      meta: {
        title: PAGE_TITLE,
        showfooter: false,
      },
    },
    {
      path: 'isactived',
      name: `${baseUrl}-isactived`,
      component: () => import('./pages/Isactived.vue'),
      meta: {
        title: PAGE_TITLE,
        showfooter: false,
      },
    },
  ],
};
export default route;
